<template>
  <BgImageLayout>
    <FormCreateProvider v-bind="providerModalOptions" @close="providerModal = false" @refresh="reRenderTable++" />

    <Grid gtr="auto 1fr" class="full-height shadow3 list-view-providers relative-position">
      <q-inner-loading :showing="loading" style="z-index: 1">
        <q-spinner color="secondary-1" size="2rem" />
      </q-inner-loading>

      <CardHeader
        :is-vendor="isVendor"
        :ag-grid="agGrid"
        @create-new-provider="providerModal = true"
        @export="$refs.providersTable.exportToExcel()"
      />

      <ProvidersTable
        v-if="showTable"
        :key="reRenderTable"
        ref="providersTable"
        :is-vendor="isVendor"
        @ag-grid="agGrid = $event"
      />
    </Grid>
  </BgImageLayout>
</template>

<script>
// Libraries
import { mapMutations, mapState } from 'vuex'
// Mixins
import { registerVuexModule } from '@/mixins/register-vuex-module'
// Components
import FormCreateProvider from '@/components/forms/form-create-provider/FormCreateProvider'
import CardHeader from './CardHeader'
import ProvidersTable from './providers-table/ProvidersTable'

export default {
  components: {
    FormCreateProvider,
    CardHeader,
    ProvidersTable
  },

  mixins: [registerVuexModule('lv-providers', () => require('./vuex-module'))],

  props: {
    providerType: {
      type: String,
      validator: val => ['publisher', 'vendor'].includes(val)
    }
  },

  data: () => ({
    agGrid: null,
    providerModal: false,
    showTable: false,
    reRenderTable: 1
  }),

  computed: {
    ...mapState('lv-providers', ['loading']),

    isVendor() {
      return this.providerType === 'vendor'
    },

    providerModalOptions() {
      return {
        showing: this.providerModal,
        stayLabel: 'Return to list',
        goLabel: `Go to ${this.isVendor ? 'Vendor' : 'Publisher'} page`,
        namespace: this.isVendor ? 'vendors' : 'publishers',
        entityName: this.isVendor ? 'vendor' : 'publisher'
      }
    }
  },

  async created() {
    const publishersOrVendors = this.isVendor ? 'vendors' : 'publishers'

    this.setLoading(true)
    await Promise.all([
      this.$store.dispatch(`${publishersOrVendors}/getMetaDataColumns`),
      this.$store.dispatch(`${publishersOrVendors}/getCreateFormData`),
      this.$store.dispatch('lv-providers/getAndSetTableState', this.isVendor ? 'vendors' : 'publishers')
    ])
    this.showTable = true
    this.setLoading(false)
  },

  methods: {
    ...mapMutations('lv-providers', ['setLoading'])
  }
}
</script>

<style lang="scss" scoped>
.list-view-providers {
  border-radius: 2px;
  overflow: hidden;
  isolation: isolate;
}
</style>
